let VueAxios = { 
    install: function (Vue) {
        let prop = {
            get: function () { return window.axios }
        };

        Object.defineProperty(Vue, 'axios', prop);
        Object.defineProperty(Vue.prototype, '$axios', prop);
    }
};

export default VueAxios;
